import { DatePicker, Tooltip } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const PublicHolidayDatePicker = ({
  publicHolidays,
  value,
  onChange,
  ...props
}) => {
  const getHolidayForDate = (date) => {
    if (!date) return null;

    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    return publicHolidays.find(holiday =>
      dayjs(holiday.date).format('YYYY-MM-DD') === formattedDate
    );
  };

  const handleChange = (date) => {
    const holiday = getHolidayForDate(date);

    if (onChange) {
      onChange(date, holiday);
    }
  };

  const isWeekend = (date) => {
    const day = dayjs(date).day();
    return day === 0 || day === 6;
  };

  const isToday = (date) => {
    return dayjs(date).isSame(dayjs(), 'day');
  };

  const dateRender = (current) => {
    const holiday = getHolidayForDate(current);
    const weekend = isWeekend(current);
    const today = isToday(current);

    if (holiday || weekend || today) {
      const tooltipTitle = holiday
        ? holiday.name
        : weekend
          ? dayjs(current).day() === 0
            ? 'Sunday'
            : 'Saturday'
          : today
            ? 'Today'
            : '';


      return (
        <Tooltip title={tooltipTitle}>
          <div style={{
            // backgroundColor: '#f0f0f0', 
            backgroundColor: today ? '#fff1b8' : '#f0f0f0',
            // color: holiday ? 'red' : 'blue', 
            color: holiday ? 'red' : weekend ? 'blue' : today ? 'green' : 'inherit',
            borderRadius: '4px',
            border: today ? '1px solid #faad14' : 'none',
          }}>
            {current.date()}
          </div>
        </Tooltip>
      );
    }

    return <div>{current.date()}</div>;
  };

  return (
    <DatePicker
      {...props}
      value={value}
      onChange={handleChange}
      dateRender={dateRender}
    />
  );
};

export default PublicHolidayDatePicker;
